import React from "react";
import Select from "react-select";
import countriesData from "./countries.json";

class CountryState extends React.Component {

  countryOptions = countriesData.map(c => ({
    value: c.code2,
    label: c.name,
    states: c.states
  }));

  constructor(props) {
    super(props);

    const defaultCountry = this.countryOptions.find(
      c => c.value === "US"
    );

    this.state = {
      selectedCountry: defaultCountry || null,
      selectedState: null
    };
  }

  componentDidMount() {
    const { selectedCountry } = this.state;

    if (this.props.onChange && selectedCountry) {
      this.props.onChange({
        country: selectedCountry,
        state: null
      });
    }
  }

  handleCountryChange = (selectedOption) => {
    this.setState({
      selectedCountry: selectedOption,
      selectedState: null
    });

    if (this.props.onChange) {
      this.props.onChange({
        country: selectedOption,
        state: null
      });
    }
  };

  handleStateChange = (selectedOption) => {
    this.setState({ selectedState: selectedOption });

    if (this.props.onChange) {
      this.props.onChange({
        country: this.state.selectedCountry,
        state: selectedOption
      });
    }
  };

  render() {
    const { selectedCountry, selectedState } = this.state;
    const { errors } = this.props;

    const stateOptions = selectedCountry
      ? selectedCountry.states.map(s => ({
          value: s.code,
          label: s.name
        }))
      : [];

    return (
      <>
        <div className="mb-3 required-field">
          <Select
            options={this.countryOptions}
            value={selectedCountry}
            onChange={this.handleCountryChange}
            placeholder="Select Country..."
            isSearchable
          />
          {errors?.country && (
            <div className="text-danger">{errors.country}</div>
          )}
        </div>

        <div className="mb-3 required-field">
          <Select
            options={stateOptions}
            value={selectedState}
            onChange={this.handleStateChange}
            placeholder="Select State..."
            isDisabled={!selectedCountry}
            isSearchable
          />
          {errors?.state && (
            <div className="text-danger">{errors.state}</div>
          )}
        </div>
      </>
    );
  }
}

export default CountryState;